export default [
  {
    path: '/statements-manual',
    name: 'statements-manual',
    meta: {
      access: 'statementView'
    },
    component: () => import('@/views/StatementManual/Table')
  },
  {
    path: '/statement-manual/:id',
    name: 'statement-manual-item',
    meta: {
      access: 'statementView'
    },
    component: () => import('@/views/StatementManual/Info.vue')
  },
  {
    path: '/statement-manual/:id/inspection/information',
    name: 'statement-manual-create-inspection',
    meta: {
      access: 'viewCharacteristic'
    },
    component: () => import('@/views/CertificationManual/Form')
  },
  {
    path: '/statement-manual/:id/inspection/characteristic',
    name: 'statement-manual-characteristic-inspection',
    meta: {
      access: 'viewCharacteristic'
    },
    component: () => import('@/views/CertificationManual/Characteristic/index.vue')
  }
]